import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';

import { DpFacetListPanelComponent } from './facet-list-panel.component';

export const facetListPanelConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.FACET_CATEGORY_PANEL]: {
      component: DpFacetListPanelComponent,
      dialogType: DIALOG_TYPE.SIDEBAR_END,
      multi: false,
      inlineRoot: true
    }
  }
};
